export default __webpack_public_path__ + "static/media/help-circle.1bb329b6.svg";